import { defineCustomElements } from '@market/web-components/loader';
export function initialize() {
  defineCustomElements();
}
export default {
  initialize
};